import { Lang } from "../states/query";

/** 文字列に関する処理をまとめたクラス。 */
export default class StringUtils {
  /**
   * 番地の形式（数字のみ、または、全角マイナスつなぎの数字）であるかを判定する。
   * @param str 判定したい文字列。
   */
  static isHouseNumber(str: string) {
    const regex = RegExp('^[0-9０-９−]+$');
    return regex.test(str);
  }

  /**
   * 文字列の末尾が数字であるかを判別する。
   * @param str 判定したい文字列。
   */
  static endsWithNumbers(str: string) {
    const regex = RegExp('.*[0-9０-９]$');
    return regex.test(str);
  }

  /**
   * カッコ付きの文字列にする。
   * 例:「第1ターミナル」→「(第1ターミナル)」
   * @param str カッコで括りたい文字列。
   */
  static addBracket(str: string) {
    return '(' + str + ')';
  }

  /** 
   * 言語設定に応じて文字列の配列の各要素を結合する。
   * @param data 結合したい文字列の配列。
   * @param lang 言語設定。
   * */
  static join(data: string[], lang: string = Lang.ja) {
    // 英語版の場合は各単語にスペースを入れて結合する。
    return (lang === Lang.en) ? data.join(' ') : data.join('');
  }

  /**
   * 文字列が緯度経度の形式になっているかを判定する。
   * @param value 判定したい文字列。
   */
  static isCoordinates(value: string) {
    /** 緯度経度のフォーマットの正規表現。 */
    const coordinetesRegexp = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?).*$/;
    /** 与えられた引数の文字列が緯度経度の形式であるかを判定した結果。 */
    // matchメソッドの戻り値がnullの場合はfalseを、それ以外（Array）の場合はtrueを返す。
    const result = value.match(coordinetesRegexp) === null ? false : true;
    return result;
  }
}
